// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products_products_info_text__b9zi7 {
    font-size: 12px;
    margin-top: 47px;
    margin-bottom: 30px;
    font-family: "Gothic";
}

.products_page_pagination_frame__CRpGJ {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

@media (min-width: 1200px) {
    .products_products_info_text__b9zi7 {
        display: none;
    }

    .products_products_box__5nnG- {
        margin-top: 100px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/products/products.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".products_info_text {\r\n    font-size: 12px;\r\n    margin-top: 47px;\r\n    margin-bottom: 30px;\r\n    font-family: \"Gothic\";\r\n}\r\n\r\n.page_pagination_frame {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .products_info_text {\r\n        display: none;\r\n    }\r\n\r\n    .products_box {\r\n        margin-top: 100px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"products_info_text": `products_products_info_text__b9zi7`,
	"page_pagination_frame": `products_page_pagination_frame__CRpGJ`,
	"products_box": `products_products_box__5nnG-`
};
export default ___CSS_LOADER_EXPORT___;
